import type { LeaseCreationDraftResponse } from '@homevest/types/rental-applications/lease-creation'

import axios from 'lib/axios'

const applicationPath = (rentalApplicationId: string) =>
  `/admin/rental_applications/${encodeURIComponent(rentalApplicationId)}`

export const leaseCreationApi = {
  async getDraft(rentalApplicationId: string): Promise<LeaseCreationDraftResponse> {
    const { data } = await axios.get<LeaseCreationDraftResponse>(
      `${applicationPath(rentalApplicationId)}/agreement_creation/draft`
    )
    return data
  },

  async submit(rentalApplicationId: string, payload: Record<string, unknown>): Promise<void> {
    await axios.post(`${applicationPath(rentalApplicationId)}/agreements`, payload)
  }
}
